
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {  MatFormFieldModule, MatInputModule, MatTableModule, MatPaginatorModule, MatSortModule, MatProgressSpinnerModule, MatSelectModule, MatIconModule, MatButtonModule, MatCheckboxModule, MatMenuModule, MatAutocompleteModule, MatRadioModule, MatNativeDateModule, MatProgressBarModule, MatDatepickerModule, MatCardModule, MatSnackBarModule, MatExpansionModule, MatTabsModule, MatTooltipModule, MatDialogModule } from '@angular/material';
import { ChangeUsercustomerModalComponent } from './change-usercustomer-modal.component';
import { CoreModule } from '@app/core/core.module';


@NgModule({
	declarations: [ ChangeUsercustomerModalComponent],
  imports: [
    CommonModule,
	  FormsModule,
	  CoreModule,
    FormsModule,
    ReactiveFormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,

    MatMenuModule,
		MatAutocompleteModule,
		MatRadioModule,
		MatNativeDateModule,
		MatProgressBarModule,
		MatDatepickerModule,
		MatCardModule,
		MatSnackBarModule,
		MatExpansionModule,
		MatTabsModule,
		MatTooltipModule,
	  MatDialogModule,
	  
  ],
  exports: [
    
  ],
  entryComponents: [
		ChangeUsercustomerModalComponent
	],
  
})
export class ChangeUserCustomerModule { }
